import React, { useState } from "react";
import AddPublicationModal from "../modals/AddPublicationModal";

const PublicationsSection = ({
  isEditing,
  publications = [],
  onUpdatePublications,
}) => {
  const [showPublicationModal, setShowPublicationModal] = useState(false);

  const handleAddPublication = (publicationData) => {
    const newPublication = {
      id: Date.now(),
      ...publicationData,
    };
    onUpdatePublications([...publications, newPublication]);
    setShowPublicationModal(false);
  };

  const handleRemovePublication = (publicationId) => {
    const updatedPublications = publications.filter(
      (publication) => publication.id !== publicationId
    );
    onUpdatePublications(updatedPublications);
  };

  const isFile = (title) => {
    const fileExtensions = [
      ".pdf",
      ".doc",
      ".docx",
      ".jpg",
      ".jpeg",
      ".png",
      ".mp4",
      ".mov",
    ];
    return fileExtensions.some((ext) => title.toLowerCase().includes(ext));
  };

  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">
          PUBLICATIONS / MEDIA
        </h2>
        {isEditing && (
          <button
            onClick={() => setShowPublicationModal(true)}
            className="px-4 py-2 border border-[#E6E6E6] bg-white text-[#1E1E1E] rounded-lg"
          >
            + Add
          </button>
        )}
      </div>

      <div className="space-y-4">
        {publications.length === 0 && (
          <div className="p-4 text-sm text-gray-500 border border-dashed border-gray-300 rounded-md">
            No publications/media added yet.
          </div>
        )}

        {publications.map((publication) => (
          <div
            key={publication.id}
            className="border-b border-[#D6DBEA] p-4 flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <span className="text-[#222A35] text-[16px] font-medium">
                {publication.title}
              </span>

              <div className="w-8 h-8 bg-[#2283FF] bg-opacity-10 rounded-lg flex items-center justify-center">
                {isFile(publication.title) ? (
                  // Eye icon for files
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 3C4.5 3 1.5 5.5 0.5 8C1.5 10.5 4.5 13 8 13C11.5 13 14.5 10.5 15.5 8C14.5 5.5 11.5 3 8 3ZM8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11Z"
                      fill="#2283FF"
                    />
                    <circle cx="8" cy="8" r="2" fill="#2283FF" />
                  </svg>
                ) : (
                  // External link icon for articles/links
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333M10 2H14V6M6 10L14 2"
                      stroke="#2283FF"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </div>
            </div>
            {isEditing && (
              <button
                onClick={() => handleRemovePublication(publication.id)}
                className="w-8 h-8 bg-[#FF4D4F1A] border border-[#FF4D4F] rounded-full flex items-center justify-center"
              >
                <span className="text-[#FF4D4F] text-sm font-bold">×</span>
              </button>
            )}
          </div>
        ))}
      </div>

      {/* Publication Modal */}
      {showPublicationModal && (
        <AddPublicationModal
          onClose={() => setShowPublicationModal(false)}
          onAdd={handleAddPublication}
        />
      )}
    </div>
  );
};

export default PublicationsSection;
